
import ForgottenPasswordForm from '~/components/organisms/auth/ForgottenPasswordForm.vue'

export default {
  components: { ForgottenPasswordForm },

  props: {
    activatorClass: {
      type: [String, Array],
      default: null,
    },
  },

  data() {
    return {
      open: false,
    }
  },
}
